<template>
  <v-reports
    PartitionItem
    v-bind:headers="headers"
    v-bind:update="update"
    v-bind:data="data"
    v-bind:num-pages="total"
    v-model="page"
    @change-pagination="changePagination"
    :data_loading="data_loading"
  >
    <template #top>
      <v-flex class="px-2 mt-2" md2 xs4>
        <v-combobox
          v-model="supplier"
          v-bind:items="all_suppliers_"
          item-text="supplier_name"
          solo
          dense
          prepend-inner-icon="mdi-account"
        />
      </v-flex>
      <v-flex class="px-2 mt-2" md2 xs4>
        <v-autocomplete
          v-model="quanty"
          :items="quantities_left"
          item-value="value"
          item-text="name"
          solo
          dense
        ></v-autocomplete>
      </v-flex>
    </template>
    <template #search_text>
      <portal to="destination">
        <Loading v-if="loading" />
      </portal>
      <v-btn icon @click="downloadExcel">
        <v-icon>mdi-download</v-icon>
      </v-btn>
      <v-dialog v-model="dialog" max-width="500px">
        <v-card>
          <v-card-title v-if="wait">Iltimos, kutib turing!</v-card-title>
          <v-card-title v-else>Excel yuklashga tayyor!</v-card-title>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn text color="primary" @click="saveExcel" :disabled="wait">
              <export-excel :data="downExcel" :name="excel_name"
                >Save Excel</export-excel
              >
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-slide-x-reverse-transition>
        <v-btn icon @click="searchActivate">
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
      </v-slide-x-reverse-transition>
      <v-slide-x-reverse-transition>
        <v-text-field
          v-model="search"
          ref="search_field"
          v-if="search_text"
          autofocus
          class="mt-3 pa-0"
          append-icon="mdi-close"
          @click:append="
            {
              (search_text = false), (search = ''), update(params);
            }
          "
          @change="update(params)"
          label="Search"
        ></v-text-field>
      </v-slide-x-reverse-transition>
    </template>
  </v-reports>
</template>
<script>
import Suppliers from "../../mixins/inventory/supplier";
import Loading from "../../components/VLoading/Loading.vue";
import fileSaver from "file-saver";
import xlsx from "xlsx";
const AllSuppliers = Object.assign(
  { ...Suppliers },
  {
    mounted() {
      this.get_all_suppliers();
    },
  }
);
export default {
  loading: false,
  mixins: [AllSuppliers],
  data: () => ({
    headers: [
      { text: "Date", value: "date", available: true },
      { text: "Purchase order", value: "p_order", available: true },
      { text: "Store", value: "service_name", available: true },
      { text: "Supplier", value: "supplier_name", available: true },
      { text: "Item name", value: "good_name", available: true },
      { text: "Quantity", value: "quantity", available: true },
      { text: "Quantity left", value: "quantity_left", available: true },
      // { text: "Queue", value: "queue", available: true },
    ],
    quanty: "all",
    loading: false,
    loader: true,
    dialog: false,
    data: [],
    page: 1,
    params: {},
    total: 0,
    data_loading: false,
    search_text: false,
    search: "",
    downExcel: [],
    excel_name: "Partition item",
    wait: true,
  }),
  methods: {
    async downloadExcel() {
      this.data_loading = true;
      // this.dialog = true;
      const min = new Date(this.params.start_date).getTime();
      const max = new Date(this.params.end_date).getTime();
      this.data_loading = false;
      const req_params = {
        limit: 10000000,
        page: 1,
        quantity_left: this.quanty,
        search: this.search,
      };
      if (this.params.service) req_params.service_id = this.params.service;
      if (this.supplier._id) req_params.supplier_id = this.supplier._id;
      const partition = this.$communicator.then(
        this,
        await this.$communicator("partition_items", {
          arguments: [min, max],
          params: req_params,
        })
      );
      const result = await partition?.data.map((par) => ({
        date: this.date_ddmmyy_hhmm(par.date),
        sku:par.sku||"-",
        Purchase_order: par.p_order,
        service_name: par.service_name,
        supplier_name: par.supplier_name,
        good_name: par.good_name,
        quantity: par.quantity,
        quantity_left: Math.round(par.quantity_left),
        cost: par.cost
        // queue: par.queue,
      }));
      // this.downExcel = await result;
      // setTimeout(() => (this.wait = false), 3000);
      const ws = xlsx.utils.json_to_sheet(result);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(wb, { bookType: "xlsx", type: "array" });
      const data = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
      });
      fileSaver.saveAs(data, "PartionValuation.xlsx");
      this.loading = false;
    },
    saveExcel() {
      this.dialog = false;
      this.wait = true;
    },
    searchActivate() {
      this.search = "";
      this.search_text = true;
    },
    changePagination(page) {
      this.page = page;
    },
    async update(params) {
      this.data_loading = true;
      this.params = params;
      const min = new Date(this.params.start_date).getTime();
      const max = new Date(this.params.end_date).getTime();
      const req_params = {
        limit: 10,
        page: this.page,
        search: this.search,
        quantity_left: this.quanty,
      };
      if (params.service) req_params.service_id = params.service;
      if (this.supplier._id) req_params.supplier_id = this.supplier._id;
      var partition = this.$communicator.then(
        this,
        await this.$communicator("partition_items", {
          arguments: [min, max],
          params: req_params,
        })
      );
      this.data = partition?.data;
      this.total = partition?.page;
      this.data_loading = false;
    },
  },
  watch: {
    supplier() {
      this.update(this.params);
    },
    page() {
      this.update(this.params);
    },
    quanty() {
      this.update(this.params);
    },
  },
  components: {
    Loading,
  },
  beforeMount() {
    this.access = this.$store.state.access;
    this.supplier = this.$store.state.supplier1;
    if (this.supplier && !this.supplier.supplier_name) {
      this.supplier.supplier_name = this.$t("all_suppliers");
    }
  },
  computed: {
    quantities_left() {
      return [
        {
          name: this.$t("all"),
          value: "all",
        },
        {
          name: this.$t("zero"),
          value: "zero",
        },
        {
          name: this.$t("not_zero"),
          value: "not_zero",
        },
      ];
    },
  },
};
</script>